const ACCEPT_TOKEN_MAP = {
	'image/*': ['.png', '.jpg', '.jpeg'],
	'application/pdf': ['.pdf'],
	'image/png': ['.png'],
	'image/jpeg': ['.jpg', '.jpeg'],
	'image/webp': ['.webp'],
};

export const DEFAULT_ACCEPT_STRING = 'image/*,.pdf';

export const DEFAULT_ACCEPT_OBJECT = {
	'application/pdf': ['.pdf'],
	'image/png': ['.png'],
	'image/jpeg': ['.jpeg', '.jpg'],
};

const expandToken = (token) => {
	if (token.startsWith('.')) return [token];
	return ACCEPT_TOKEN_MAP[token] || [token];
};

export const getAcceptedExtensions = (accept) => {
	if (!accept) return [];
	if (typeof accept === 'string') {
		return [...new Set(
			accept
				.split(',')
				.map((f) => f.trim())
				.filter(Boolean)
				.flatMap(expandToken),
		)];
	}
	if (typeof accept === 'object') {
		return [...new Set(Object.values(accept).flat())];
	}
	return [];
};
